export default {
  listHeaders() {
    return [
      { text: 'Proje', value: 'santiye' },
      { text: 'Pozisyon', value: 'pozisyon' },
      { text: 'Kişi Sayısı', value: 'kisisayisi' },
      { text: 'Reddet', value: 'Buttons' },
      { text: 'Onayla', value: 'Buttons' },
    ];
  },
};
